import { extendTheme } from '@chakra-ui/react';
import { BarChartTheme } from '@pluxee-design-system/barchart';
import { theme as plxTheme } from '@pluxee-design-system/core';
import { DatePickerTheme } from '@pluxee-design-system/datepicker';
import DashboardCard from 'common/cards/DashboardCard.theme';
import GridCard from 'common/cards/GridCard.theme';
import ProductCard from 'common/cards/ProductCard.theme';
import FaqSideMenuItem from 'common/overlays/FaqSideMenuItem.theme';
import Modal from 'common/overlays/Modal.theme';

const HeaderBaseStyle = plxTheme.components.Header.baseStyle();

export const theme = extendTheme({
  ...plxTheme,
  breakpoints: {
    ...plxTheme.breakpoints,
    mdd: '960px',
  },
  components: {
    ...plxTheme.components,
    BarChart: BarChartTheme,
    DatePicker: {
      ...DatePickerTheme,
      baseStyle: {
        ...DatePickerTheme.baseStyle,
        datePicker: {
          ...DatePickerTheme?.baseStyle?.datePicker,
          '.react-datepicker-wrapper': {
            width: '100%',
          },
          '.chakra-input': {
            width: '100%',
          }
        },
      },
    },
    Checkbox: {
      ...plxTheme.components.Checkbox,
      sizes: {
        medium: {
          ...plxTheme.components.Checkbox.sizes.medium,
          label: {
            ...plxTheme.components.Checkbox.sizes.medium.label,
            paddingTop: '0.171875rem', // lol...
            // 4+10.5+5.5 = 20px, checkbox height 24px, font has 1.5px offset
            // 24-(20+1.5) = 2.5px, 2.5/2 = 1.25px, 1.25+1.5=2.75px, (2.75px)/16px = ^ rem
          },
        },
      },
    },
    // TODO: remove when Hamburger icon officially added to Header
    Header: {
      ...plxTheme.components.Header,
      baseStyle: {
        ...HeaderBaseStyle,
        navigation: {
          ...HeaderBaseStyle.navigation,
          display: 'flex',
        },
      },
    },
    Link: {
      ...plxTheme.components.Link,
      variants: {
        ...plxTheme.components.Link.variants,
        primary: {
          ...plxTheme.components.Link.variants.primary,
          text: {
            borderBottom: '0.125rem solid transparent',
            borderTop: 'none',
            borderRight: 'none',
            borderLeft: 'none',
          },
        },
      },
    },
    Modal: {
      ...plxTheme.components.Modal,
      sizes: {
        ...plxTheme.components.Modal.sizes,
        ...Modal.sizes,
      },
    },
    DashboardCard,
    GridCard,
    ProductCard,
    FaqSideMenuItem,
  },
  styles: {
    ...plxTheme.styles,
    global: {
      ...plxTheme.styles.global,
      body: {
        ...plxTheme.styles.global.body,
        bg: 'semantic.background.primary',
        color: 'semantic.text.primary',
        fontFamily: 'body',
      },
    },
  },
});
